import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=1aeb052a&scoped=true&"
import script from "./UserSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserSelect.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeb052a",
  null
  
)

export default component.exports